import axios from "app/axios";
import { apiSapCheckConnection } from "app/axios/urlApi";

export const checkSapConnnection = () => {
  return axios.get(apiSapCheckConnection);
};
